module.exports = __webpack_public_path__ + "img/page_img4.4cf0d2eb.jpg";